import { io, Socket } from 'socket.io-client';
import { useAuthStore } from '../stores/useAuthStore.js';

const SOCKET_URL = import.meta.env.VITE_SOCKET_URL ?? (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3001');

let socket: Socket | null = null;

export function getSocket(): Socket {
  if (!socket) {
    const token = useAuthStore.getState().accessToken;
    socket = io(SOCKET_URL, {
      auth: {
        token: token ? `Bearer ${token}` : ''
      },
      autoConnect: false
    });
  }
  return socket;
}

export function connectSocket() {
  const s = getSocket();
  const token = useAuthStore.getState().accessToken;
  s.auth = { token: token ? `Bearer ${token}` : '' };
  if (!s.connected) {
    s.connect();
  }
}

export function disconnectSocket() {
  if (socket) {
    if (socket.connected) {
      socket.disconnect();
    }
    socket = null;
  }
}
